<template>
    <div>
        <breadcrumb class="px-4 bg-light pb-0" :items="breadcrumbs" />
        <div class="page-content">
            <staff-list v-if="isStaffList" />
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import StaffList from "@/components/setting-staff/staff-list.vue";
import Breadcrumb from "@/components/commons/breadcrumb.vue";

export default {
    components: {
        StaffList,
        Breadcrumb
    },
    computed: {
        staffStatus() {
            return this.$store.getters["staff/status"];
        },
        isStaffList() {
            return this.$route.name == "stafflist";
        },
        isStaffNew() {
            return this.$route.name == "staff_new";
        },
        isStaffView() {
            return this.$route.name == "staff_view";
        },
        staffViewDetails() {
            return this.$store.getters["staff/staffDetails"];
        },
        isCanViewStaffList() {
            return (
                this._hasAccess("setting.staff.view") ||
                this._hasAccess("setting.staff.update") ||
                this._hasAccess("setting.staff.delete") ||
                this._hasAccess("setting.staff.reset") ||
                this._hasAccess("setting.staff.after_hour_access")
            );
        },
        breadcrumbs() {
            let breadcrumbs = [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                }
            ];

            if (this.isStaffNew) {
                if (this.isCanViewStaffList) {
                    breadcrumbs.push({
                        text: `List of ${this.staffStatus.label} Staff`,
                        to: {
                            name: "stafflist",
                            query: {
                                status: this.staffStatus.label.toLowerCase()
                            }
                        }
                    });
                }

                breadcrumbs.push({
                    text: "New",
                    to: ""
                });
            } else if (this.isStaffView) {
                if (this.staffViewDetails && this.staffViewDetails.fullname) {
                    if (this.isCanViewStaffList) {
                        breadcrumbs.push({
                            text: `List of ${this.staffStatus.label} Staff`,
                            to: {
                                name: "stafflist",
                                query: {
                                    status: this.staffStatus.label.toLowerCase()
                                }
                            }
                        });
                    }

                    breadcrumbs.push({
                        text: `${this.staffViewDetails.fullname} (${this.staffViewDetails.role_label})`,
                        to: ""
                    });
                }
            } else {
                breadcrumbs.push({
                    text: `List of ${this.staffStatus.label} Staff`,
                    to: ""
                });
            }

            return breadcrumbs;
        }
    }
};
</script>
